import type { StandardServicePageContent } from "~/content/servicePage";

export const FireEquipmentInspectionContent: StandardServicePageContent = {
  heroTitle: "Przegląd sprzętu przeciwpożarowego",
  quickFactsTitle: "Najważniejsze informacje w skrócie",
  quickFacts: [
    {
      label: "Jak często",
      value: "Minimum co rok",
      description:
        "Gaśnice i urządzenia przeciwpożarowe powinny być objęte przeglądami technicznymi oraz konserwacją zgodnie z dokumentacją producenta, nie rzadziej niż raz w roku.",
    },
    {
      label: "Ile kosztuje",
      value: "Najczęściej wycena za liczbę urządzeń",
      description:
        "Koszt zależy od liczby gaśnic, hydrantów i punktów w obiekcie oraz od zakresu dokumentacji. Mały lokal z kilkoma urządzeniami wycenia się inaczej niż budynek z wieloma kondygnacjami.",
    },
    {
      label: "Co obejmuje",
      value: "Gaśnice, hydranty, oznaczenia i protokół",
      description:
        "Kontrola obejmuje stan techniczny sprzętu, jego kompletność, dostępność, oznakowanie i wpisy do dokumentacji. Celem jest potwierdzenie realnej gotowości do użycia, a nie tylko formalnego przeglądu.",
    },
    {
      label: "Kiedy działać wcześniej",
      value: "Po użyciu sprzętu, remoncie lub zmianie układu obiektu",
      description:
        "Dodatkowa kontrola ma sens po użyciu gaśnicy, uszkodzeniu hydrantu, zmianie aranżacji lokalu albo przeniesieniu wyposażenia. To częste sytuacje w sklepach, biurach i lokalach usługowych.",
    },
  ],
  faqTitle: "Najczęstsze pytania o przegląd sprzętu przeciwpożarowego",
  sections: [
    {
      title: "Na czym polega przegląd sprzętu przeciwpożarowego",
      paragraphs: [
        `Przegląd sprzętu przeciwpożarowego polega na sprawdzeniu, czy urządzenia przeznaczone do pierwszej reakcji na pożar są kompletne, sprawne i gotowe do użycia. W praktyce chodzi nie tylko o formalny wpis, ale o realne potwierdzenie, że sprzęt zadziała w sytuacji zagrożenia.`,
        `To usługa ważna dla właścicieli budynków, wspólnot, biur, hoteli, lokali usługowych i magazynów. Regularne przeglądy pomagają uporządkować stan wyposażenia, ograniczyć ryzyko braków podczas kontroli i utrzymać dokumentację potrzebną zarządcy obiektu.`,
        `Po kontroli użytkownik powinien wiedzieć, które elementy są sprawne, co wymaga naprawy lub wymiany i czy rozmieszczenie sprzętu nadal odpowiada rzeczywistym potrzebom budynku.`,
      ],
    },
    {
      title: "Przegląd gaśnic i kontrola hydrantów",
      paragraphs: [
        `Przegląd gaśnic obejmuje ocenę stanu zbiornika, zaworu, węża, plomb, oznaczeń i parametrów zależnych od typu urządzenia. Celem jest potwierdzenie, że sprzęt może zostać bezpiecznie użyty i jest właściwie dobrany do rodzaju zagrożenia w danej strefie.`,
        `Kontrola hydrantów skupia się na kompletności urządzenia, dostępności, stanie szafki, zaworu, węża, prądownicy i oznakowania. Sam fakt, że hydrant znajduje się na ścianie, nie oznacza jeszcze, że będzie nadawał się do użycia podczas pożaru.`,
        `W praktyce właśnie w tej części przeglądu wychodzą najczęściej braki wyposażenia, uszkodzenia mechaniczne, problemy z dostępnością i nieczytelne oznaczenia. To dlatego przegląd powinien być traktowany jako realna kontrola gotowości, a nie wyłącznie formalność.`,
      ],
    },
    {
      title: "Obowiązkowe przeglądy PPOŻ i dokumentacja po kontroli",
      paragraphs: [
        `Sprzęt przeciwpożarowy w budynku powinien być objęty przeglądami technicznymi i czynnościami konserwacyjnymi zgodnie z dokumentacją producenta, nie rzadziej niż raz w roku. Dotyczy to zarówno gaśnic, jak i innych urządzeń przeciwpożarowych używanych w obiekcie.`,
        `Dla właściciela albo zarządcy oznacza to konieczność regularnego serwisowania wyposażenia i prowadzenia dokumentacji. Wpisy, naklejki serwisowe i protokoły mają znaczenie nie tylko organizacyjne, ale też praktyczne przy kontroli obiektu oraz planowaniu uzupełnień sprzętu.`,
        `Po wizycie powinno być jasne, które urządzenia są sprawne, co trzeba wymienić i jakie działania należy zaplanować. Tylko taka dokumentacja daje realną kontrolę nad stanem wyposażenia przeciwpożarowego.`,
      ],
    },
    {
      title: "Cena przeglądu sprzętu przeciwpożarowego",
      paragraphs: [
        `Cena przeglądu sprzętu przeciwpożarowego zależy od liczby urządzeń, rodzaju obiektu i zakresu czynności. Inaczej wycenia się kilka gaśnic w małym lokalu, a inaczej pakiet obejmujący gaśnice, hydranty i dokumentację dla większego budynku.`,
        `Na koszt wpływa również to, czy przegląd dotyczy standardowej kontroli okresowej, czy obejmuje dodatkowe sprawdzenia po użyciu sprzętu, uszkodzeniach albo zmianach w obiekcie. W większych miastach znaczenie mają też dojazd i organizacja wizyty poza godzinami pracy lokalu.`,
        `Przy porównywaniu ofert warto sprawdzić, czy cena obejmuje sam przegląd, czy również wpisy do dokumentacji, oznaczenia serwisowe, protokół i wskazanie braków do uzupełnienia. To właśnie ten zakres najczęściej decyduje o realnej wartości usługi.`,
      ],
    },
  ],
  scopeTitle: "Zakres usług przeglądu sprzętu przeciwpożarowego",
  scopeItems: [
    "Przegląd gaśnic",
    "Kontrola hydrantów",
    "Ocena węży i prądownic",
    "Weryfikacja oznakowania PPOŻ",
    "Sprawdzenie plomb i cechowań",
    "Ocena dostępności urządzeń",
    "Wpisy do dokumentacji",
    "Protokół pokontrolny",
  ],
  seo: {
    title: "Przegląd sprzętu przeciwpożarowego: gaśnice, hydranty, cena",
    description:
      "Przegląd sprzętu przeciwpożarowego dla lokali, biur i budynków. Sprawdź zakres kontroli gaśnic i hydrantów, obowiązki roczne oraz to, od czego zależy cena usługi.",
  },
};
